'use strict';

var React = require('react');

var SvgFirstVisitMajor = function SvgFirstVisitMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.962 9.726c-.023-.078-2.296-7.726-9.962-7.726s-9.939 7.648-9.962 7.726a1 1 0 0 0 0 .548c.023.078 2.296 7.726 9.962 7.726s9.939-7.648 9.962-7.726a.999.999 0 0 0 0-.548zm-8.876-3.723a1 1 0 0 1 .901 1.161l-1 6a1 1 0 1 1-1.973-.328l.677-4.064-.243.123a1 1 0 0 1-.895-1.79l2-1a1 1 0 0 1 .533-.102z"
  }));
};

exports.SvgFirstVisitMajor = SvgFirstVisitMajor;
